
import { useRef } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import objectsNameTypes from '../../../enums/objectsNameTypes';
import useLmsAction from '../../../hooks/useLmsAction';
import { getUserSchoolProperty } from '../../../utils/utils';

const Albert = () => {
    const iframeRef = useRef(null);
    const general = useSelector(state => state.general);
    const userDetails = useSelector(state => state.auth.userDetails);
    const { texts, lang } = useSelector(state => state.translate);
    useLmsAction(window.location.href, objectsNameTypes.albert, false)

    useEffect(() => {
        const loadIframeContent = () => {
            if (iframeRef.current) {
                // Dynamically create the form within the iframe
                const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
                const form = iframeDoc.createElement("form");
                form.method = "POST";
                form.action = `${window.config.baseApiUrl}/auth/authorize`; // Replace with your API endpoint

                const supervisionId = getUserSchoolProperty(userDetails, 'supervisionId');
                const educationTypeId = getUserSchoolProperty(userDetails, 'educationTypeId');

                const params = {
                    response_type: "id_token",
                    client_id: window.config.client_id,
                    redirect_uri: window.config.redirect_uri,
                    scope: "profile",
                    nonce: "random_nonce",
                    prompt: "none",
                    state: JSON.stringify({
                        providerLink: window.config.providerLink,
                        lang: lang ?? "he",
                        theme: general.themeColor,
                        gender: userDetails?.genderId ?? 1,
                        supervisionId: supervisionId ?? 1,
                        educationTypeId: educationTypeId ?? 1
                    }),
                };

                for (const [key, value] of Object.entries(params)) {
                    const input = iframeDoc.createElement("input");
                    input.type = "hidden";
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                }

                // Append the form to the iframe's body and submit it
                iframeDoc.body.appendChild(form);
                form.submit(); // Redirect happens within the iframe
            }
        };
        if (userDetails && lang)
            loadIframeContent();
        // eslint-disable-next-line 
    }, [userDetails, lang]);


    useEffect(() => {
        if (iframeRef.current && iframeRef.current.contentWindow) {
            iframeRef.current.contentWindow.postMessage(
                { action: "themeColorChange", themeColor: general.themeColor }, '*'
            );
        }
    }, [general.themeColor]);

    useEffect(() => {
        if (iframeRef.current && iframeRef.current.contentWindow) {
            iframeRef.current.contentWindow.postMessage(
                { action: "langChange", lang: lang }, '*'
            );
        }
    }, [lang]);

    return (
        <div>
            <iframe
                ref={iframeRef}
                frameBorder={0}
                title={texts.albertTitle}
                style={{ width: "100%", height: "100%", position: "absolute" }}
                allow="microphone *"
            ></iframe>
        </div>
    );
};

export default Albert;
